import React, {useState, useEffect, useRef} from 'react'

import classes from './Bucket.module.css'
import { useDroppable } from '@dnd-kit/core';
import clsx from 'clsx';
import Button from '@/components/shared/Button/Button';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { observer } from 'mobx-react-lite';

const Bucket = ({children, with_media}) => {

  const bucketCtnrRef = useRef(null)
  const {isOver, setNodeRef} = useDroppable({id: "bucket"});
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if(bucketCtnrRef.current) {
      console.log("bucketCtnrRef.current", bucketCtnrRef.current)
      setHeight(bucketCtnrRef.current.offsetHeight)
    }
  }, []);

  let style = {}
  if(height) style.height = height

  return (
    <div ref={bucketCtnrRef} style={style} >
      <div
      ref={setNodeRef}
      className={clsx(classes.Bucket,
      isOver && classes.over,
      with_media && classes.with_media,
      height && classes.heightSet)}>
        {children}
      </div>

      {/* {visibleIndex > 0 &&
      <Button onClick={() => setVisibleIndex(i => i-1)} className={classes.bucket_left} icon={<FaChevronLeft />} />} */}


      {/* {visibleIndex < children.length - 1 &&
      <Button onClick={() => setVisibleIndex(i => i+1)} className={classes.bucket_right} icon={<FaChevronRight />} />} */}

    </div>
  )
}

export default observer(Bucket);
